/* eslint-disable */
import { DashboardTileCategory } from '../dto/dashboard-tile-category';
import { Priority } from '../dto/priority';

export interface NewsListDto {
  id: number;
  title: string;
  description: string;
  buttonText?: string | null;
  buttonLinkUrl?: string | null;
  category?: DashboardTileCategory | null;
  priority: Priority;
  createdAt: Date;
  hasImg: boolean;
}

export const fixNewsListDtoFromJson = (dto?: NewsListDto | null): void => {
  if (!dto) {
    return;
  }
  dto.createdAt = dto.createdAt && new Date(dto.createdAt);
};

export const fixNewsListDtoToJson = (dto?: NewsListDto | null): void => {
  if (!dto) {
    return;
  }
};
